<template>
  <div>
    <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" color="#CCCED3"></topIcon>
    <van-loading type="spinner" v-if="nodata"/>
    <div style="background: #F7F8F9;">
      <div class="logo" v-if="dominItem.templateId === 'temp1'">
        {{ dominItem.logoName || 'Logo' }}
        <div class="category">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
        </div>
      </div>

      <div class="logo" v-if="dominItem.templateId === 'temp2'">
        <div class="category">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
        </div>
        {{ dominItem.logoName || 'Logo' }}
      </div>

      <div class="logo" style="display: flex; flex-direction: column" v-if="dominItem.templateId === 'temp3'">
        {{ dominItem.logoName || 'Logo' }}
        <div class="category">
          <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
              item.label
            }}</span>
        </div>

      </div>
    </div>


    <div style="padding: 0 10%; margin-top: 50px">
      <div class="news-page">
        <!-- 最新新闻区域 -->
        <div class="latest-news-section">
          <div class="news-grid">
            <!-- 左侧大图新闻 -->
            <div class="news-large" @click="toDetail(bestItem.articleShortName)">
              <div class="news-image-container">
                <img :src="bestItem.articleImage"/>
              </div>
              <h3 class="twoHde" style="margin-left: 20px">{{ bestItem.articleTitle }}</h3>
              <p class="news-excerpt small " style="margin-left: 20px; margin-bottom: 10px">
                {{ bestItem.articleIntro }}</p>
<!--              <div class="news-meta" style="margin-bottom: 20px">-->
<!--                <span>{{ bestItem.uploadTime }}</span>-->
<!--              </div>-->

              <span style="display: inline-block; font-size: 22px; font-weight: bold
; height: 50px; line-height: 50px;width: 100%; padding-left: 20px; border-bottom: 3px solid #0C4767; margin-bottom: 20px">
                {{ $t('con_recommended') }}</span>

              <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;">
                <div class="news-large" v-for="item in articleList1" @click="toDetail(item.articleShortName)">
                  <div class="news-image-container" style="height: 200px">
                    <img :src="item.articleImage"/>
                  </div>
                  <h3 class="twoHde" style="margin-left: 20px">{{ item.articleTitle }}</h3>
                  <p class="news-excerpt small " style="margin-left: 20px; margin-bottom: 10px">
                    {{ item.articleIntro }}</p>
<!--                  <div class="news-meta">
                    <span>{{ item.uploadTime }}</span>
                  </div>-->
                </div>

              </div>
            </div>

            <!-- 右侧新闻列表 -->


            <div class="news-list">
                            <span style="display: inline-block; font-size: 22px; font-weight: bold
; height: 50px; line-height: 50px;width: 100%; padding-left: 20px; border-bottom: 3px solid #0C4767; margin-bottom: 20px">
                {{ $t('con_recommended') }}</span>
              <div v-for="(item, index) in articleList" :key="item.id" class="news-item"
                   @click="toDetail(item.articleShortName)">
                <img :src="item.articleImage" alt="">
                <div class="news-item-content">
                  <h4 class="twoHde" style="margin-left: 0">{{ item.articleTitle }}</h4>
<!--                  <div class="news-meta small" style="margin-left: 0">-->
<!--                    <span>{{ item.uploadTime }}</span>-->
<!--                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="but-box">
                      <span style="display: inline-block; font-size: 22px; font-weight: bold
; height: 50px; line-height: 50px;width: 100%; padding-left: 20px; border-bottom: 3px solid #0C4767; margin-bottom: 20px">
                {{ $t('con_recommended') }}</span>
        <div class="news-dashboard">
          <!-- 左侧主要报告区域 -->
          <div class="main-report" v-for="item in articleList2.slice(0, 1)" @click="toDetail(item.articleShortName)">
            <div>
              <h2>{{ item.articleTitle }}</h2>
              <p>
                {{ item.articleIntro }}
              </p>
            </div>
            <img
                :src="item.articleImage"
                class="main-chart"
            />

          </div>
          <!-- 右侧新闻卡片区域 -->
          <div class="news-cards">
            <div class="card" v-for="item in articleList2.slice(1, 5)" @click="toDetail(item.articleShortName)">
              <div>
                <h2 class="twoHde" style="margin-left: 0">{{ item.articleTitle }}</h2>
                <p class="threeHde" style="margin-left: 0">
                  {{ item.articleIntro }}
                </p>
              </div>
              <img
                  :src="item.articleImage"
                  class="card-image"
              />

            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="buttom">
      <div class="kuai">
        <div class="btn-logo">{{ dominItem.logoName || 'Logo' }}</div>
        <div class="explore">
          <div>
          <span v-for="item in typeList" @click="changeType(item.id)"
                style="cursor: pointer; color: #000000">{{ item.label }}</span>
          </div>
          <buttomIcon v-if="dominItem.nationId !== 'cn'"></buttomIcon>
        </div>

        <footers is00="is04" widd="none" :articleListlast="articleListlast" :current="current"></footers>
      </div>
    </div>
  </div>
</template>

<script>
import {getOne, newContent} from "@/api"
import topIcon from '../../icons/small.vue'
import {format} from "date-fns";
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"

export default {
  components: {topIcon, buttomIcon, footers},


  props: {
    dominItem: Object
  },

  name: "index",
  data() {
    return {
      bestItem: {},
      nodata: false,
      // template: 'temp3',
      current: 1,
      recommendList: [],
      latestNewsList: [],
      articleList: [],
      articleList1: [],
      articleList2: [],
      articleList3: [],
      articleList4: [],
      articleListlast: [],
      recommendList1: [],
      typeList: [        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_home'), id: 1},
        {label: this.$t('con_LIFESTYLE'), id: 5},
        {label: this.$t('con_BUSINESS'), id: 2},
      ],
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  created() {
    this.nationId = JSON.parse(localStorage.getItem('dominItem')).nationId


    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    } else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    }
  },

  methods: {
    openLink(link) {
      window.open(link)
    },
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },


    // 获取推荐文章列表
    getArticleList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 10,
        articleNationId: this.nationId,
        articleType: 'con_recommended'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows
        this.nodata = false
      })
    },


    // 获取最新文章
    getLatestNewsList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 4,
        articleNationId: this.nationId,
        articleType: 'con_latest'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList1 = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取热门文章
    getRecommendList() {
      newContent({
        articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 5,

        articleNationId: this.nationId, articleType: 'con_hot_con'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList2 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList1() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 6,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList3 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList2() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 9,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList4 = res.rows
      })
    },

    // 获取最下面文章列表  相关文章
    getArticleListlast() {
      // this.nodata = true
      newContent({
        articleCategoryId: this.current,
        pageNum: 3,
        pageSize: 6,
        articleNationId: this.nationId,
        articleType: 'con_related'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.news-page {
  padding: 30px 0;

  /* 主要新闻样式 */
  .main-news {
    display: flex;
    margin-bottom: 40px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-5px);
    }
  }

  .main-news-image {
    flex: 1;
    min-height: 300px;
    overflow: hidden;
  }

  .main-news-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .main-news:hover .main-news-image img {
    transform: scale(1.05);
  }

  .main-news-content {
    flex: 1;
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .category-badge {
    display: inline-block;
    padding: 5px 15px;
    background: #004F8B;
    color: white;
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 15px;
    border-radius: 4px;
  }

  .category-badge.overlay {
    position: absolute;
    top: 15px;
    left: 15px;
    z-index: 1;
  }

  .category-badge.small {
    padding: 3px 10px;
    font-size: 12px;
    margin-bottom: 10px;
  }

  .main-news-content h1 {
    font-size: 28px;
    margin-bottom: 20px;
    color: #333;
    line-height: 1.3;
  }

  .news-excerpt {
    color: #666;
    font-size: 16px;
    line-height: 1.6;
    margin-bottom: 20px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .news-excerpt.small {
    font-size: 14px;
    -webkit-line-clamp: 3;
  }

  .news-meta {
    display: flex;
    align-items: center;
    color: #999;
    font-size: 14px;
  }

  .news-meta span {
    margin-right: 20px;
  }

  .news-meta .read-more {
    color: #004F8B;
    font-weight: 500;
    margin-left: auto;
  }

  .news-meta.small {
    font-size: 12px;
  }

  /* 最新新闻区域 */
  .latest-news-section {
    margin-bottom: 50px;
  }

  .section-title {
    font-size: 22px;
    font-weight: 700;
    margin-bottom: 25px;
    color: #333;
    padding-bottom: 10px;
    border-bottom: 1px solid #e0e0e0;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  .news-grid {
    display: flex;
    max-width: 1200px;
    margin: auto;
    gap: 30px;
  }

  .news-large {
    flex: 1;
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    overflow: hidden;
    transition: transform 0.3s ease;
  }

  .news-large:hover {
    transform: translateY(-5px);
  }

  .news-image-container {
    position: relative;
    height: 400px;
    overflow: hidden;
  }

  .news-image-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .news-large:hover .news-image-container img {
    transform: scale(1.05);
  }

  .news-large h3 {
    font-size: 20px;
    margin-top: 10px;
    color: #333;
    line-height: 1.3;
  }

  .news-large .news-excerpt {
    margin-top: 10px;
    margin-bottom: 0;
  }

  .news-large .news-meta {
    padding: 0 20px 20px;
    border-top: 1px solid #eee;
    margin: 0 20px;
    padding-top: 15px;
  }

  .news-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .news-item {
    background: #fff;
    padding: 15px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    gap: 20px;
    border-left: 3px solid transparent;

    img {
      border-radius: 5px;
      width: 100px;
      height: 100px
    }
  }

  .news-item:hover {
    transform: translateX(5px);
    border-left: 3px solid #0C4767;
  }

  .news-item h4 {
    font-size: 16px;
    color: #333;
    margin-bottom: 10px;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  /* 热门新闻区域 */
  .popular-news-section {
    margin: 0 auto 40px;
    max-width: 1200px;
  }

  .popular-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  .popular-item {
    background: #fff;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    overflow: hidden;
    transition: transform 0.3s ease;
  }

  .popular-item:hover {
    transform: translateY(-5px);
  }

  .popular-image-container {
    height: 160px;
    overflow: hidden;
  }

  .popular-image-container img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }

  .popular-item:hover .popular-image-container img {
    transform: scale(1.05);
  }

  .popular-item .category-badge {
    margin: 15px 15px 10px;
  }

  .popular-item h4 {
    font-size: 16px;
    margin: 10px 20px;
    color: #333;
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .popular-item .news-meta {
    padding: 0 15px 15px;
    border-top: 1px solid #eee;
    margin: 0 15px;
    padding-top: 10px;
  }
}

.but-box {
  .news-dashboard {
    padding: 20px;
    display: flex;
  }

  .current-date {
    text-align: right;
    margin-bottom: 10px;
    font-size: 18px;
  }

  .main-report {
    width: 50%;
    position: relative;
    margin-bottom: 20px;

    div {
      position: absolute;
      bottom: 0;
      height: 100%;
      background: rgba(0, 0, 0, 0.2);
      width: 100%;
      left: 0;
      display: flex;
      flex-direction: column;
      justify-content: end;
      color: #fff;
      padding: 20px;
    }
  }


  .main-report h2 {
    font-size: 24px;
    margin-bottom: 10px;
  }

  .main-report p {
    font-size: 16px;
    margin-bottom: 15px;
  }

  .main-chart {
    width: 100%;
    height: 440px;
    object-fit: cover;
  }

  .main-report h3 {
    font-size: 18px;
    margin-bottom: 5px;
  }

  .main-report h1 {
    font-size: 28px;
    margin-bottom: 10px;
  }

  .news-cards {
    width: 50%;
    margin-left: 20px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
  }

  .card {
    flex: 0 0 calc(50% - 10px);

    position: relative;

    div {
      position: absolute;
      bottom: 20px;
      height: calc(100% - 20px);
      background: rgba(0, 0, 0, 0.2);
      width: 100%;
      left: 0;
      display: flex;
      flex-direction: column;
      justify-content: end;
      color: #fff;
      padding: 10px;
    }

  }

  .card-image {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }

  .card h3 {
    font-size: 16px;
    margin-bottom: 5px;
  }

  .card h2 {
    font-size: 18px;
  }
}


.logo {
  width: 1200px;
  margin:  auto;
  padding: 20px 0;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  font-size: 30px;
  color: #00BE10;

  justify-content: space-between;
  font-weight: bold;
  text-align: left;
}

.logo-temp1 {
  padding: 0 20px 0 10%;
}

.logo-temp2 {
}

.category {
  min-height: 40px;
  //margin-bottom: 30px;
  color: #000000;
  font-weight: bold;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid #E6E8EA;
  line-height: 38px;

  span {
    font-weight: 500;
    font-size: 18px;
    display: inline-block;
    padding: 0 20px;
    cursor: pointer;
    position: relative;
    //border-bottom: 3px solid #ffffff;
  }

  span:hover {
    color: #00BE10;
    //background: #eeeeee;
    transition: all .1s ease;
    //border-bottom: 3px solid #eeeeee;
  }

  .choose {
    transition: all .1s ease;
    color: #566E3D;
    //border-bottom: 3px solid #000000;
  }
}

.buttom {
  background: #ffffff;
  border-top: 2px solid #000000;
  display: flex;
  flex-direction: column;

  .kuai {
    width: 1260px;
    margin: auto;
  }

  .btn-logo {
    margin-left: 50px;
    font-size: 40px;
    color: #32B507;
    font-weight: bold;
    background: transparent;
  }

  .explore {
    display: flex;
    justify-content: space-between;
    margin-left: 50px;
    margin-top: 30px;
    margin-bottom: 20px;
    align-items: center;
    font-weight: bold;

    span {
      margin-right: 10px;
      font-size: 15px;
      color: #2E3D4D !important;
    }

    span:hover{
      color: #32B507 !important;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #ffffff;
  background: #000000;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  display: flex;
  flex-wrap: wrap;

  span {
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.imgsss {
  width: 30px;
  height: 30px;
}

.imgsss:nth-child(4) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(5) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(6) {
  width: 40px;
  height: 40px;
}

.article-image1 {
  width: 80px;
  height: 80px;
  object-fit: cover;
}

</style>